import React from 'react';
import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  *, *:before, *:after {
    box-sizing: border-box;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  }

  /*
    Add accessible line-height
    Improve text rendering
  */
  body {
    line-height: calc(1em + 0.725rem);
    -webkit-font-smoothing: antialiased;
    margin: 0;
    padding: 0;
    background: var(--color-background);
    color: var(--color-text);
    transition: background-color 0.2s ease, color 0.2s ease;
  }

  /*
    Improve media defaults
  */
  img, picture, video, canvas, svg {
    display: block;
    max-width: 100%;
  }

  /*
    Remove built-in form typography styles
  */
  input, button, textarea, select {
    font: inherit;
  }

  /*
    Avoid text overflows
  */
  p, h1, h2, h3, h4, h5, h6 {
    overflow-wrap: break-word;
  }

  /*
    Create a root stacking context
  */
  #root, #__next {
    isolation: isolate;
  }

  a {
    color: var(--color-secondary);
    transition: color 0.2s ease;
  }

  a:visited {
    color: var(--color-visited);
  }

  a:hover {
    opacity: 0.8;
  }

  /* Hide content initially to prevent FOUC */
  html {
    transition: opacity 0.2s ease;
  }
`;

export default GlobalStyles;